(function () {
	'use strict';

	angular.module('qbePortal').controller('VehicleSubTypeSelector', VehicleSubTypeSelector);

	VehicleSubTypeSelector.$inject = ['$scope', 'serviceResponseRepository', 'quoteModelFactory', 'labelService'];

	function VehicleSubTypeSelector($scope, serviceResponseRepository, quoteModelFactory, labelService) {
		var vm = this;

		vm.registerHierarchy = function (name, setHierarchyFn) {
			vm.setHierarchy({name: name, setHierarchyFn: setHierarchyFn});
		}

		vm.onValueChanged = function () {
			vm.update({name: vm.name, value: vm.fieldValue});
		}

		vm.getOptions = function () {
			var options;

			switch (vm.vehicleType) {
				case 'caravan':
					options = labelService.getOptionsFor('caravanSubTypes');
					break;
				case 'campertrailer':
					options = labelService.getOptionsFor('camperTrailerSubTypes');
					break;
				case 'goodscarryingtrailer':
					options = labelService.getOptionsFor('goodsCarryingTrailerSubTypes');
					break;
			}

			return options;
		}

	}

	angular.module('qbePortal').component('vehicleSubTypeSelector', {
		templateUrl: '../ngviews/components/qbVehicleSubTypeSelector.html',
		controller: VehicleSubTypeSelector,
		controllerAs: 'vm',
		bindings: {
			name: '@',
			update: '&',
			setHierarchy: '&',
			validationSelector: '@',
			fieldValue: '<',
			vehicleType: '<',
			labelWildcard: '<'
		}
	});
})();
